<style scoped lang="less">
.src {
    width: 100px;
    height: 130px;
    border: 1px solid #c1c1c1;
    box-sizing: border-box;
    float: left;
    margin: 10px 10px 0 0;
    transition: all ease 0.5s;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    img {
        width: 100%;
        height: 100px;
        object-fit: contain;
    }
    span.name {
        width: 100%;
        font-size: 10px;
        padding: 0 3px;
        text-align: center;
        height: 28px;
        word-break: break-all;
    }
    span.fanda {
        display: none;
        position: absolute;
        bottom: 3px;
        left: 3px;
        color: #409eff;
        font-size: 12px;
        font-weight: bold;
    }
    &:hover {
        span.fanda {
            display: inline;
        }
    }
}

.line-container {
    .next {
        margin-left: 20px;
    }
}
</style>


<template>
    <el-dialog :visible.sync="show" title="选择图片" width="920px">
        <div class="block-mini">
            <el-input v-model="keyword" size="mini" placeholder="关键词搜索" @keyup.native.enter="fetchData"></el-input>
        </div>

        <div class="line-container block">
            <!-- <el-upload action="http://up-z0.qiniu.com" :on-success="handleSelectImage" :data="uploadData" :multiple="true" :show-file-list="false" :before-upload="beforeAvatarUpload">
                <el-button size="small" type="primary" :loading="uploading1">点击上传</el-button>
            </el-upload> -->

            <el-input placeholder="输入图片网址直接回车上传" size="medium" v-model="uploadUrl" @keyup.native.enter="enterUploadUrl">
            </el-input>
        </div>
        <p>上传文件大小不能超过1MB</p>
        <div>
            <div v-for="item in data" class="src" :key="item._id" @click="chooseItem(item)">
                <img :src="item.src">
                <span class="name">
                    {{item.name}}
                </span>
                <a :href="item.src" target="_blank" @click.stop="">
                    <span class="fanda">放大</span>
                </a>
            </div>
            <div class="clear"></div>
        </div>
        <el-pagination class="block" background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="pageNum+1" @current-change="changePage">
        </el-pagination>
    </el-dialog>
</template>

<script>
import bus from "../../util/bus";
import { loginState } from "../../util/login";
import qiniuUpload from "../mixins/qiniuUpload";
import { HttpClient } from "../../util/http";

export default {
    mixins: [qiniuUpload],
    data() {
        return {
            show: false,
            uploading1: false,
            data: [],
            total: 0,
            pageSize: 16,
            pageNum: 0,
            types: [],
            keyword: "",
            uploadUrl: ""
        };
    },
    created() {
        bus.on("select-image", async () => {
            this.show = true;
            this.fetchData();
        });
    },
    computed: {
        safeKeyword() {
            return this.keyword
                .split("")
                .filter(char => "* ()".indexOf(char) < 0)
                .join(".*");
        }
    },
    methods: {
        chooseItem(item) {
            this.show = false;
            bus.emit("select-image-result", item);
        },
        changePage(page) {
            this.pageNum = page - 1;
            this.fetchData();
        },
        beforeAvatarUpload(file) {
            let isLt2M = file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过1MB!");
            }
            return isLt2M;
        },
        async fetchData() {
            let cond = {};
            if (this.safeKeyword) {
                cond.name = {
                    $regex: this.safeKeyword
                };
            }
            let res = await HttpClient.post("/restful", {
                model: "ImageStore",
                cond,
                sort: {
                    _id: -1
                },
                withCount: true,
                pageSize: this.pageSize,
                pageNum: this.pageNum
            });
            this.data = res.result;
            this.total = res.count;
        },
        async uploadSrc(src, key, name) {
            this[key] = true;
            await this.httpUpload(src, name);
            this[key] = false;
        },
        async enterUploadUrl() {
            await this.httpUpload(this.uploadUrl, "");
            this.uploadUrl = "";
        },
        async httpUpload(src, name) {
            let data = {
                src,
                name
            };
            let res = await HttpClient.post("/imagestore", data);
            this.data = [res, ...this.data].slice(0, this.pageSize);
        },
        async handleSelectImage(e, next) {
            let src = this.joinCDN(e.key);
            this.uploadSrc(src, "uploading1", next.name);
        }
    }
};
</script>
